exports = module.exports = require("../../../../css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n.vux-group-tip, .vux-group-tip p {\n  font-size:0.4375rem;\n  color:#888;\n  text-align:center;\n  padding-top:0.3em;\n  padding-left:0.3125rem;\n  padding-right:0.15625rem;\n}\n.vux-group-tip .weui-icon {\n  padding-right: 0.09375rem;\n}\n", ""]);

// exports
